<main id="app-container" theme>
    <app-toast aria-live="polite" aria-atomic="true"></app-toast>
    <router-outlet></router-outlet>
</main>
